import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./styles/Signin.css";
import Spinner from "../freelancer/components/Spinner";

const SigninForm = ({ onForgotPasswordClick, displayStatus }) => {
  let navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassCheck, setShowPassCheck] = useState(false)
  const handleLogin = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const response = await fetch("https://globalworker-backend.vercel.app/api/auth/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      if (response.ok) {
        setLoading(false);
        localStorage.setItem("token", data.authtoken);
        navigate("/");
        console.log("Login successful.");
        console.log(data.authtoken);
      } else {
        setLoading(false);
        console.error("Login failed:", data.error);
        appendAlert(data.error, "danger");
        console.error("Login failed:", data.error);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error during login:", error.message);
      appendAlert("Error during login. Please try again.", "danger");
      console.error("Error during login:", error.message);
    }
  };

  
  const showPassword = () =>{
      if(!showPassCheck){
        setShowPassCheck(true)
      }
      else if(showPassCheck){
        setShowPassCheck(false)
      }
  }

  const alertPlaceholder = document.getElementById('liveAlertPlaceholder')
const appendAlert = (message, type) => {
  const wrapper = document.createElement('div')
  wrapper.innerHTML = [
    `<div class="alert alert-${type} alert-dismissible" role="alert">`,
    `   <div>${message}</div>`,
    '   <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>',
    '</div>'
  ].join('')

  alertPlaceholder.append(wrapper)
}
return (
  <>
    <div id="liveAlertPlaceholder"></div> 
      <form className="mt-4" onSubmit={handleLogin}>
        <h3 id="login-heading">Logga in</h3>
        <div className="dropdown">
          <button
            className="btn btn-secondary dropdown-toggle"
            type="button"
            id="languageDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Svenska (Sverige)
          </button>
          <ul className="dropdown-menu" aria-labelledby="languageDropdown">
            <li>
              <a
                className="dropdown-item"
                href="#"
                onClick={() => changeLanguage("Svenska (Sverige)")}
              >
                Svenska (Sverige)
              </a>
            </li>
            <li>
              <a
                className="dropdown-item"
                href="#"
                onClick={() => changeLanguage("English")}
              >
                English
              </a>
            </li>
            {/* Add more language options as needed */}
          </ul>
        </div>
        <hr id="divider" />
        <label className="form-lebels" htmlFor="signin-email">
          E-post
        </label>
        <input
          type="email"
          id="signin-email"
          className="form-control mb-2"
          placeholder="example123@gmail.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <label className="form-lebels" htmlFor="signin-Password">
          Lösenord
        </label>
        <input
          type={showPassCheck ? 'text' : "password"}
          id="signin-Password"
          className="form-control"
          placeholder="***********"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <div className="main-check-container mt-2">
          <div className="form-check-container mb-1">
            <input
              type="checkbox"
              id="autoSizingCheck2"
              className="form-check-input-field"
              style={{marginRight: '3px'}}
              value={showPassCheck} 
              onClick={showPassword} 
            />
            <label className="form-check-lab" htmlFor="autoSizingCheck2">
              Visa lösenord
            </label>
          </div>
            <Link to="#" onClick={onForgotPasswordClick}>
              Glömt ditt lösenord?
            </Link>
        </div>
        <button type="submit" id="login-btn" className="btn btn-primary mt-3" >
          Logga in
        </button>
        <div className="regToLoginDiv" style={{ display: displayStatus }}>
          <p>Registrera dig som ny användare? </p>
          <p>
            <Link to="/signup">Registrera</Link>
          </p>
        </div>
        <div className='mt-4'>
          {loading && <Spinner/>}
        </div>
      </form>
  </>
);
};

export default SigninForm;
// Add this function outside the component
function changeLanguage(language) {
  document.getElementById("languageDropdown").innerText = language;
}
